import { useEffect, useRef } from "react";
import styled from "styled-components";

const Dropdown = ({
  trigger,
  content,
  width = 256,
  className = "",
  onDropdownChange,
  isOpen = false,
}) => {
  const dropdownContentRef = useRef(null);
  const triggerRef = useRef(null);

  const handleTrigger = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onDropdownChange(!isOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const isOutsideContent =
        !dropdownContentRef.current?.contains(event.target);
      const isOutsideTrigger =
        !triggerRef.current?.contains(event.target);
      if (isOutsideContent && isOutsideTrigger) {
        onDropdownChange(false);
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [onDropdownChange]);
  return (
    <DropdownWrapper className={className}>
      <DropdownTrigger
        ref={triggerRef}
        onClick={(e) => handleTrigger(e)}
        className="trigger"
      >
        {trigger}
      </DropdownTrigger>
      <DropdownContents
        width={width}
        ref={dropdownContentRef}
        className="contents"
        $isOpen={isOpen}
      >
        {content}
      </DropdownContents>
    </DropdownWrapper>
  );
};

const DropdownTrigger = styled.div`
  color: #222;
`;

const DropdownContents = styled.div`
  position: absolute;
  top: 32px;
  right: 0;
  width: auto;
  min-height: 64px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 0px 15px -3px rgba(0, 0, 0, 0.25);
  z-index: 99;
  padding: 16px;
  width: ${(props) => (props?.width ? `${props?.width}px` : "256px")};
  visibility: ${(props) => (props.$isOpen ? "visible" : "hidden")};
  pointer-events: ${(props) => (props.$isOpen ? "auto" : "none")};
  button {
    display: block;
    width: 100%;
  }
  p {
    overflow-wrap: anywhere;
  }
`;
const DropdownWrapper = styled.div`
  position: relative;
`;

export default Dropdown;
